export default function () {
  return {
    budgetSummary: {},
    budgetSummaryLoading: false,
    budgetTransactions: [],
    budgetTransactionsLoading: false
  };
}
